import styled from 'styled-components';
import { BasicProps, BasicPropTypes, shouldForwardBasicProp } from './props';

export const Row = styled.div.withConfig({
	shouldForwardProp: shouldForwardBasicProp,
})`
    display: flex;
    flex-direction: row;
    
    ${BasicProps};
`;

Row.propTypes = {
	...BasicPropTypes,
};
